/**
 * Display mode options for guest information
 */
export enum GuestInfoDisplayMode {
  USER = 'user',
  BOOKING = 'booking'
}

/**
 * Where `GuestInfo.phone` comes from: the booking itself, or — when the booking has none — the check-in form
 */
export type GuestPhoneSource = 'booking' | 'checkin';

/**
 * Guest information for displaying in tables and components across the application
 * Contains both user and booking data - display mode determines which is shown
 */
export interface GuestInfo {
  readonly id?: number;
  readonly name: string;
  readonly email?: string;
  readonly phone?: string;
  readonly phoneSource?: GuestPhoneSource;
  readonly lastAppLogin?: Date;
  // Original booking guest information (always preserved)
  readonly bookingName?: string;
  readonly bookingEmail?: string;
  readonly bookingPhone?: string;
}
